import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { initialState } from "../config/constants";

import { login, getProtectedData } from "./authSlice.thunks";

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsAuth: (state, action: PayloadAction<boolean>) => {
      state.isAuth = action.payload;
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
      state.error.email = "";
    },
    setPassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload;
      state.error.password = "";
    },
    setRemember: (state, action: PayloadAction<boolean | undefined>) => {
      if (action.payload) {
        state.rememberChecked = action.payload;
      } else {
        state.rememberChecked = !state.rememberChecked;
      }
    },
    setPasswordVisibility: (
      state,
      action: PayloadAction<boolean | undefined>,
    ) => {
      if (action.payload) {
        state.passwordVisible = action.payload;
      } else {
        state.passwordVisible = !state.passwordVisible;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      login.rejected,
      (state, action: PayloadAction<{ email: string; password: string }>) => {
        console.log(action.payload);
        state.isLoading = false;
        if (action.payload) {
          state.error.email = action.payload.email;
          state.error.password = action.payload.password;
        }
        state.isAuth = false;
      },
    );
    builder.addCase(login.pending, (state) => {
      state.isLoading = true;
      state.error.password = "";
      state.error.email = "";
      state.isAuth = false;
    });
    builder.addCase(login.fulfilled, (state, action: PayloadAction<string>) => {
      localStorage.setItem("token", action.payload);
      state.isLoading = false;
      state.error.password = "";
      state.error.email = "";
      state.isAuth = true;
    });

    builder.addCase(getProtectedData.rejected, (state) => {
      state.isLoading = false;
      state.isAuth = false;
    });
    builder.addCase(getProtectedData.pending, (state) => {
      state.isLoading = true;
      state.isAuth = false;
    });
    builder.addCase(getProtectedData.fulfilled, (state) => {
      state.isAuth = true;
      state.isLoading = false;
    });
  },
});

export const { actions } = authSlice;

export default authSlice.reducer;
